import { MenuItem, Select } from "@material-ui/core";
import arrow from "../../assets/images/dropdown-arrow.svg";
import "./Lang-dropdown/Langselect.scss";
import { useState } from "react";

const DropDown = ({
  value,
  options,
  onChange,
  id,
  name,
  setState,
  disabled,
}) => {
  const [val, setVal] = useState(value);

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    disablePortal: false,
    keepMounted: true,
    getContentAnchorEl: null, // ✅ required in v4
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: name === "priority" ? "150px" : 410,
        backgroundColor: "#2E2E2E",
        color: "#D9D9D9",
        borderRadius: "6px",
        marginTop: name === "priority" ? 6 : 10,
      },
    },
    MenuListProps: {
      style: { padding: 0 },
    },
  };
  const ArrowIcon = () => (
    <img
      src={arrow}
      alt="dropdown arrow"
      style={{ width: 16, height: 16, marginRight: 10 }}
    />
  );
  const handleonChange = (e) => {
    setVal(e.target.value);
    if (name === "priority") {
      onChange(e, id);
    } else {
      console.log("val", e.target.value);
      setState(e.target.value);
    }
  };
  function displayOption(option) {
    if (name === "priority") {
      return option;
    } else {
      if (name === "Peer Group") {
        return `${option?.ageGroup} (${option?.name})`;
      } else {
        return option.name;
      }
    }
  }
  return (
    <Select
      readOnly={disabled}
      value={name === "priority" ? val : value}
      onChange={handleonChange}
      MenuProps={MenuProps}
      displayEmpty
      className={`${disabled ? "disable" : ""} custom-dropdown`}
      IconComponent={ArrowIcon}
      style={{
        height: name === "priority" ? 32 : 40,
        width: name === "priority" ? 150 : "100%",
      }}
    >
      {name !== "priority" && (
        <MenuItem value="" disabled>
          <span style={{ color: "#a9a9a9", fontSize: 14, cursor: "pointer" }}>
            Select a {name}
          </span>
        </MenuItem>
      )}
      {options.map((option) => (
        <MenuItem
          key={option?.id}
          value={name === "priority" ? option : option.id}
        >
          {displayOption(option)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DropDown;
